import secureLS from 'secure-ls'

const ls = new secureLS()
export const get = (key) => ls.get(key)
export const set = (key, data) => ls.set(key, data)
export const rem = () => ls.removeAll()

export const isLogin = () => (ls.get('token') ? true : false);